import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrLabeledIcon from "UI/FnrLabeledIcon/FnrLabeledIcon";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

const AnotherGroupNotice = () => {
  const [title] = extendedFieldHooks.useTitle();
  const [icon] = extendedFieldHooks.useIcon();
  const [groupName] = extendedFieldHooks.useGroupName();

  return (
    <FnrVerticalGap $gap="20px" data-cy="ExtendedFields_AnotherGroupNotice">
      <FnrLabeledIcon icon={icon} variant="greyHeaderColumn">
        {title}
      </FnrLabeledIcon>
      <FnrTypography color="textSecondary">
        Flocknote will already ask members of this group for their{" "}
        {title.toString().toLowerCase()} because it&apos;s a part of the{" "}
        <em>{groupName}</em> group. You can edit it from the{" "}
        <em>{groupName}</em> group settings.
      </FnrTypography>
    </FnrVerticalGap>
  );
};

export default AnotherGroupNotice;
